import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js';

Chart.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

export default function GraphViewer({ config }) {
  const {
    title = 'Graph Viewer',
    description = '',
    sliders = [],
    generate,
    options: customOptions = {},
  } = config;

  const initialSliderValues = sliders.reduce((acc, slider) => {
    acc[slider.key] = slider.default;
    return acc;
  }, {});

  const [sliderValues, setSliderValues] = useState(initialSliderValues);
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    const { labels, datasets } = generate(sliderValues);
    setChartData({ labels, datasets });
  }, [sliderValues, generate]);

  const chartOptions = {
    responsive: true,
    animation: {
      duration: 300,
      easing: 'easeOutQuart'
    },
    scales: {
      x: { title: { display: true, text: 'X' } },
      y: { title: { display: true, text: 'Y' }, min: 0 },
    },
    ...customOptions,
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      <h2 className="text-xl font-bold mb-2 text-indigo-700">{title}</h2>
      {description && <p className="text-sm text-gray-600 mb-4">{description}</p>}

      {sliders.map(({ label, key, min, max, step }) => (
        <div key={key} className="mb-4">
          <label className="block mb-1 text-sm text-gray-700">
            {label}: <strong>{sliderValues[key]}</strong>
          </label>
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={sliderValues[key]}
            onChange={(e) => setSliderValues({ ...sliderValues, [key]: parseFloat(e.target.value) })}
            className="w-full"
          />
        </div>
      ))}

      <Line data={chartData} options={chartOptions} />
    </div>
  );
}